import size1 from '../../images/size1.png';
import size2 from '../../images/size2.png';
import size3 from '../../images/size3.png';
import size4 from '../../images/size4.png';
import size5 from '../../images/size5.png';
import size6 from '../../images/size6.png';
import size7 from '../../images/size7.png';
import size8 from '../../images/size8.png';
import size9 from '../../images/size9.png';
import size10 from '../../images/size10.png';
import size11 from '../../images/size11.png';
import size12 from '../../images/size12.png';
import size13 from '../../images/size13.png';
import size14 from '../../images/size14.png';
import size15 from '../../images/size15.png';
import size16 from '../../images/size16.png';
import size17 from '../../images/size17.png';
import size18 from '../../images/size18.png';
import size19 from '../../images/size19.png';
import size20 from '../../images/size20.png';
import size21 from '../../images/size21.png';
import size22 from '../../images/size22.png';
import size23 from '../../images/size23.png';
import size24 from '../../images/size24.png';
import size25 from '../../images/size25.png';
import size26 from '../../images/size26.png';

type SizeLabel = { label: string; unit: 'м' | 'мм' };

export type LestnicyTypeConfig = { name: string; image: string; sizes: SizeLabel[] };

export const TYPE_CONFIG: Record<string, LestnicyTypeConfig> = {
  lestnicy1: {
    name: 'Размер односекционной лестницы',
    image: size1,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
    ],
  },
  lestnicy2: {
    name: 'Размер двухсекционной лестницы',
    image: size2,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'мм' },
      { label: 'I', unit: 'мм' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
      { label: 'L', unit: 'м' },
    ],
  },
  lestnicy3: {
    name: 'Размер двухсекционной лестницы с тросовой тягой',
    image: size3,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'мм' },
      { label: 'H', unit: 'мм' },
      { label: 'I', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  lestnicy4: {
    name: 'Размер трехсекционной лестницы (1)',
    image: size4,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'I', unit: 'м' },
      { label: 'J', unit: 'мм' },
      { label: 'K', unit: 'мм' },
      { label: 'L', unit: 'м' },
      { label: 'M', unit: 'м' },
      { label: 'N', unit: 'м' },
    ],
  },
  lestnicy5: {
    name: 'Размер трехсекционной лестницы (2)',
    image: size5,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'I', unit: 'м' },
      { label: 'J', unit: 'мм' },
      { label: 'K', unit: 'мм' },
      { label: 'L', unit: 'м' },
      { label: 'M', unit: 'м' },
    ],
  },
  lestnicy6: {
    name: 'Размер телескопической двухсекционной лестницы',
    image: size6,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'N', unit: 'м' },
      { label: 'M', unit: 'м' },
      { label: 'O', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'P', unit: 'м' },
      { label: 'Q', unit: 'м' },
    ],
  },
  lestnicy7: {
    name: 'Размер телескопической односекционной лестницы',
    image: size7,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'C1', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'D1', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
    ],
  },
  stremyanki1: {
    name: 'Размер стремянки бытовой',
    image: size8,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
    ],
  },
  stremyanki2: {
    name: 'Размер стремянки (1)',
    image: size9,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'C*', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
    ],
  },
  stremyanki3: {
    name: 'Размер стремянки (2)',
    image: size10,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
    ],
  },
  stremyanki4: {
    name: 'Размер стремянки (3)',
    image: size11,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  podmosty1: {
    name: 'Размер подмостьев (1)',
    image: size12,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
    ],
  },
  podmosty2: {
    name: 'Размер подмостьев (2)',
    image: size13,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  podmosty3: {
    name: 'Размеры вышки-тура (1)',
    image: size14,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  podmosty4: {
    name: 'Размеры вышки-тура (2)',
    image: size15,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  podmosty5: {
    name: 'Размеры вышки-тура (3)',
    image: size16,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  podmosty6: {
    name: 'Размеры вышки-тура (4)',
    image: size17,
    sizes: [
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
      { label: 'A1', unit: 'м' },
      { label: 'B1', unit: 'м' },
      { label: 'C1', unit: 'м' },
      { label: 'D1', unit: 'м' },
      { label: 'E1', unit: 'м' },
      { label: 'F1', unit: 'м' },
      { label: 'G1', unit: 'м' },
      { label: 'H1', unit: 'м' },
      { label: 'A2', unit: 'м' },
      { label: 'B2', unit: 'м' },
      { label: 'C2', unit: 'м' },
      { label: 'D2', unit: 'м' },
      { label: 'E2', unit: 'м' },
      { label: 'F2', unit: 'м' },
      { label: 'A3', unit: 'м' },
      { label: 'B3', unit: 'м' },
      { label: 'C3', unit: 'м' },
      { label: 'D3', unit: 'м' },
      { label: 'E3', unit: 'м' },
      { label: 'F3', unit: 'м' },
      { label: 'G3', unit: 'м' },
      { label: 'A4', unit: 'м' },
      { label: 'B4', unit: 'м' },
      { label: 'C4', unit: 'м' },
      { label: 'D4', unit: 'м' },
      { label: 'E4', unit: 'м' },
      { label: 'F4', unit: 'м' },
      { label: 'G4', unit: 'м' },
    ],
  },
  podmosty7: {
    name: 'Размеры вышки-тура (5)',
    image: size18,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'I', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
    ]
  },
  transformery1: {
    name: 'Размер малярного стола',
    image: size19,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'H', unit: 'м' },
    ],
  },
  transformery2: {
    name: 'Размер лестницы помоста',
    image: size20,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'K', unit: 'м' },
      { label: 'L', unit: 'м' },
      { label: 'M', unit: 'м' },
      { label: 'Q', unit: 'м' },
      { label: 'R', unit: 'м' },
      { label: 'S', unit: 'м' },
    ],
  },
  transformery3: {
    name: 'Размер трансформера (1)',
    image: size21,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
    ],
  },
  transformery4: {
    name: 'Размер трансформера (2)',
    image: size22,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
    ],
  },
  transformery5: {
    name: 'Размер лестницы шарнирной',
    image: size23,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
    ],
  },
  transformery6: {
    name: 'Размер трансформера (3)',
    image: size24,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
      { label: 'L', unit: 'м' },
      { label: 'M', unit: 'м' },
      { label: 'O', unit: 'м' },
      { label: 'N', unit: 'м' },
      { label: 'I', unit: 'м' },
      { label: 'J', unit: 'м' },
      { label: 'H', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'P', unit: 'м' },
      { label: 'Q', unit: 'м' },
      { label: 'K', unit: 'м' },
    ],
  },
  kruk: {
    name: 'Размер крука',
    image: size25,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'E', unit: 'м' },
      { label: 'F', unit: 'м' },
      { label: 'G', unit: 'м' },
    ],
  },
  ploschatka: {
    name: 'Размер площадки',
    image: size26,
    sizes: [
      { label: 'A', unit: 'м' },
      { label: 'B', unit: 'м' },
      { label: 'C', unit: 'м' },
      { label: 'D', unit: 'м' },
      { label: 'Расстояние между ступенями', unit: 'мм' },
      { label: 'Профиль ступени', unit: 'мм' },
    ],
  },
};

export const TYPE_OPTIONS = Object.keys(TYPE_CONFIG).map((typeKey) => ({
  value: typeKey,
  label: TYPE_CONFIG[typeKey].name,
}));